export function waitForPageFetches(nuxt, timeout = 5000) {
  if (!nuxt?.isFetching) return Promise.resolve()

  return new Promise(resolve => {
    let unwatch = () => {}
    const finish = () => {
      clearTimeout(timer)
      unwatch()
      resolve()
    }
    const timer = setTimeout(finish, timeout)
    unwatch = nuxt.$watch('isFetching', fetching => {
      if (!fetching) finish()
    })
  })
}
